import React from "react";

const WithdrawalPayments = () => {
  const withDrawPaymentData = [
    { title: "Withdrawable Amount", name: "0.00 $" },
    { title: "Balance", name: "0.00 $" },
    { title: "Unplayed amount", name: "0.00 $" },
  ];
  return (
    <div className="flex flex-col mt-2  justify-between bg-[rgb(255,255,255,.05)] rounded ">
      {withDrawPaymentData.map((e, index) => {
        return (
          <span
            className={`flex flex-row justify-between px-[20px] items-center py-[5px] ${index === 1 ? "bg-[rgb(255,255,255,.1)]" : ""}`}
            key={index}
          >
            <h1 className="text-[rgb(255,255,255,.6)] text-[12px]">{e.title}</h1>
            <p className={`mt-[4px] text-[12px] ${index === 1 ? "text-[rgb(170,127,0,1)]" : "text-[rgb(16,145,33,1)]"}`}>{e.name}</p>
          </span>
        );
      })}
    </div>
  );
};

export default WithdrawalPayments;
